// @flow
import React from "react";
import styles from "./ControlledTriggerIcon.scss";
import defaultTriggerStyles from "./DefaultTrigger.scss";
import activeTileTriggerStyles from "./ActiveTileTrigger.scss";
import inactiveTileTriggerStyles from "./InactiveTileTrigger.scss";

export type ControlledTriggerIconTypes = "default" | "activeTile" | "inactiveTile";

type ControlledTriggerIconProps = {
  type: ControlledTriggerIconTypes
};

const getTriggerStyles = {
  default: defaultTriggerStyles,
  activeTile: activeTileTriggerStyles,
  inactiveTile: inactiveTileTriggerStyles
};

const ControlledTriggerIcon = ({ type }: ControlledTriggerIconProps) => {
  const triggerStyles = getTriggerStyles[type];

  return (
    <svg
      width="54"
      height="54"
      className={styles.icon}
      viewBox="0 0 54 54"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <circle className={triggerStyles.circle} stroke="red" fill="blue" cx="26" cy="26" r="26" />
        <g
          className={triggerStyles.icon}
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M29.3 39.153h-6.601a.767.767 0 0 1-.766-.768c0-2.705-1.322-5.224-3.622-6.911a12.968 12.968 0 0 1-5.294-11.15c.334-6.592 5.762-11.999 12.356-12.31 3.59-.166 7.003 1.105 9.599 3.582A12.888 12.888 0 0 1 39 21.003c0 4.19-2.045 8.15-5.47 10.581-2.169 1.545-3.465 4.084-3.465 6.799a.77.77 0 0 1-.766.77zM23 41.5h6M24 43.5h4M25 45.5h2" />
        </g>
      </g>
    </svg>
  );
};

ControlledTriggerIcon.defaultProps = {
  type: "default"
};

export default ControlledTriggerIcon;
